import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-12 md:py-16 lg:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm font-medium mb-3">
            <i className="ri-grid-line"></i>
            <span>分类导航</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            漫画分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
            按题材精准划分八大漫画分类，韩漫、日漫、国漫跨区收录，助你快速锁定心头好
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto">
          {indexData.map((item) => (
            <a
              key={item.name}
              href="#cards"
              className="group flex flex-col items-center text-center p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-500 transition-colors">
                <i className={`${item.icon} text-primary-600 group-hover:text-background-50 text-xl md:text-2xl transition-colors`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1">
                {item.name}
              </h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full">
                {item.count} 部
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}